export default __webpack_public_path__ + "static/media/avatar_70.96965146.png";